import { OibFullInfoEmployee } from "../../../../models/Committee";

export const EMPTY_OIB_FULL_INFO_EMPLOYEE: OibFullInfoEmployee = {
  oib: "",
  firstName: "",
  lastName: "",
};

export const MULTI_SELECT_SINGLE_SELECTION_LIMIT = 1;
